// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.post-module__tile___YAufs {
  display: block;
  position: relative;
  font-weight: 400;
  margin: 0 10px 50px;
}
.post-module__tile__modal-image___yC_MI {
  position: absolute;
  top: 0;
}
.post-module__tile__small-text___cG5pI {
  font-size: 0.5625rem;
  padding-top: 2px;
}
.post-module__tile__badge___vquo8 .post-module__flag__image___p0krp {
  vertical-align: top !important;
}
.post-module__tile__time___LFIxU {
  margin-bottom: 5px;
  margin-left: 5px;
  font-size: 0.6875rem;
  font-weight: 600;
  text-align: right;
  color: var(--neutral75, #424547);
}
.post-module__tile__border___Ni8l8 {
  border-radius: 50px;
  border: 4px solid var(--base, #f4f4f7);
}
.post-module__tile__header___WFvxr {
  padding: 0 20px 0;
  margin-top: -55px;
  color: var(--neutral100, #2c2e30);
}
.post-module__tile__avatar___SWu3U {
  display: block;
  border-radius: 50px;
  height: 70px;
  width: 70px;
  margin: 0 auto;
  box-shadow: 0px 0px 0px 4px var(--base, #f4f4f7);
  background-color: var(--base, #f4f4f7);
  transition: all 0.25s ease;
}
.post-module__tile__avatar--small___ta_lu {
  height: 50px;
  width: 50px;
  box-shadow: none;
  background-color: var(--surface1, #fff);
  transition: all 0.1s ease;
  margin: 0 18px 0 6px !important;
}
.post-module__tile__avatar--small___ta_lu.post-module__small-width___jm_uE {
  width: 43px;
  margin: 0 25px 0 6px !important;
}
.post-module__tile__avatar--extra-small___eAXnY {
  height: 40px;
  width: 40px;
  box-shadow: none;
  background-color: var(--surface1, #fff);
  transition: all 0.1s ease;
}
.post-module__tile__avatar--list___Flrfc {
  display: inline-block;
  border: none;
  vertical-align: middle;
  margin: 5px;
  margin-bottom: 20px;
}
.post-module__tile__avatar--list--user___GdROm {
  border: 1px solid var(--neutral30, #e3e6e8);
  border-radius: 50%;
}
.post-module__tile__avatar--small___ta_lu:hover, .post-module__tile__avatar--extra-small___eAXnY:hover {
  transform: scale(1.05);
}
.post-module__tile__content___y5Val {
  font-size: 0.875rem;
  padding: 20px;
}
@media screen and (max-width: 480px) {
  .post-module__tile__content___y5Val {
    padding: 15px 10px;
  }
}
.post-module__tile__content--inverse___M2M2F {
  color: var(--surface1, #fff);
}
.post-module__tile__link___IqWa5 {
  color: var(--primary600, #4b286d) !important; /* For Safari 3.1 to 6.0 */
  transition: color 0.2s;
  text-decoration: underline;
}
.post-module__tile__link___IqWa5:focus {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
}
.post-module__tile__username___WKcUW {
  font-weight: 600;
  word-break: break-word;
  color: var(--primary600, #4b286d) !important; /* For Safari 3.1 to 6.0 */
  transition: color 0.2s;
  text-decoration: underline;
}
.post-module__tile__username___WKcUW:focus {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
}
.post-module__tile__username___WKcUW:hover {
  color: #371E47 !important;
  cursor: pointer;
}
.post-module__tile__html___yoodh a {
  color: #4B286D !important; /* For Safari 3.1 to 6.0 */
  transition: color 0.2s;
}
.post-module__tile__html___yoodh ul,
.post-module__tile__html___yoodh ol {
  margin: 10px 0;
  padding-left: 28px;
}
.post-module__tile__html___yoodh ul li {
  list-style: initial;
}
.post-module__tile__html___yoodh ol li {
  list-style: decimal;
}
.post-module__tile__job___eugwg {
  font-size: 0.75rem;
  color: var(--neutral75, #424547);
}
.post-module__tile__username--inverse___hKCcV {
  color: var(--surface1, #fff) !important;
}
.post-module__tile__username--inverse___hKCcV:focus {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
}
.post-module__tile__username--dark___O9_c0 {
  color: var(--neutral100, #2c2e30) !important;
}
.post-module__tile__username--dark___O9_c0:focus {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
}
.post-module__tile__emphasize___M884G {
  font-weight: 600;
}
.post-module__tile__headline___JRJPp {
  padding: 20px;
  min-height: 100px;
  font-size: 1.125rem;
  border-bottom: 1px solid var(--neutral30, #e3e6e8);
}
@media screen and (max-width: 480px) {
  .post-module__tile__headline___JRJPp {
    padding: 15px 10px;
    min-height: 90px;
  }
}
.post-module__tile__headline___JRJPp:hover, .post-module__tile__headline___JRJPp:active, .post-module__tile__headline___JRJPp:focus {
  text-decoration: none;
}
.post-module__tile__headline___JRJPp:hover .post-module__tile__headline--username___lQUq1, .post-module__tile__headline___JRJPp:active .post-module__tile__headline--username___lQUq1, .post-module__tile__headline___JRJPp:focus .post-module__tile__headline--username___lQUq1 {
  text-decoration: underline;
}
.post-module__tile__subtext___MaBd7 {
  font-size: 0.75rem;
}
.post-module__tile__text--padding___xXzG7 {
  margin: 15px 0;
  padding-top: 42px;
}
.post-module__tile__text--first___E5B3j {
  text-align: center;
  color: var(--gold, #e9b725);
}
.post-module__tile__text--second___YlbGp {
  text-align: center;
  color: var(--silver, #c7c7c7);
}
.post-module__tile__text--third___Wdvqz {
  text-align: center;
  color: var(--bronze, #cc8b54);
}
.post-module__tile__image--first___w6dEX {
  box-shadow: 0 0 0 2px white, 0 0 0 4px var(--gold, #e9b725);
}
.post-module__tile__image--second___RlqG7 {
  box-shadow: 0 0 0 2px white, 0 0 0 4px var(--silver, #c7c7c7);
}
.post-module__tile__image--third___Xqajf {
  box-shadow: 0 0 0 2px white, 0 0 0 4px var(--bronze, #cc8b54);
}
.post-module__tile__overlay___KiPv5 {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(var(--neutral100-rgb, 44, 46, 48), 0.25);
  left: 0;
  top: 0;
}
.post-module__tile__inner-content___QcV19 {
  position: relative;
}
.post-module__tile__activity___AObFg {
  padding: 10px 20px;
  border-top: 1px solid var(--neutral15);
  color: var(--neutral100, #2c2e30);
  text-align: left;
  font-size: 0.75rem;
  opacity: 1;
  position: relative;
}
.post-module__tile__icon___o1chr {
  font-size: 1rem;
  margin-right: 5px;
  vertical-align: text-bottom;
}
.post-module__tile__photo--holder___WWaV6 {
  margin: 0 20px 20px;
  transition: all 0.25s ease;
  cursor: pointer;
  max-height: 500px;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.post-module__tile__photo--holder___WWaV6 > img {
  width: 100%;
}
.post-module__tile__photo___zGglD {
  width: 100%;
}
.post-module__tile__footer___v4Rf9 {
  border-top: 1px solid var(--neutral15);
  overflow: hidden;
  background-color: var(--surface1, #fff);
}
.post-module__tile__footer_action___bRRPW {
  width: calc(100% - 145px);
}
@media screen and (max-width: 480px) {
  .post-module__tile__footer_action___bRRPW {
    width: calc(100% - 106px);
  }
}
.post-module__tile__footer_count___oCbQY {
  border-left: 1px solid var(--neutral15);
  width: 145px;
  height: 40px;
  position: absolute;
  right: 0;
  color: var(--neutral75, #424547);
  padding: 9px 15px;
  line-height: 22px;
}
@media screen and (max-width: 480px) {
  .post-module__tile__footer_count___oCbQY {
    padding: 9px 5px;
    width: 106px;
    line-height: initial;
  }
}
.post-module__tile__footer_count___oCbQY [class^=icon-],
.post-module__tile__footer_count___oCbQY [class*=" icon-"] {
  margin: 0 5px 0 0;
  font-size: 1.125rem;
  vertical-align: text-bottom;
}
@media screen and (max-width: 480px) {
  .post-module__tile__footer_count___oCbQY [class^=icon-],
  .post-module__tile__footer_count___oCbQY [class*=" icon-"] {
    font-size: 0.75rem;
    vertical-align: middle;
  }
}
.post-module__tile__footer_count___oCbQY [class^=icon-]:nth-child(3),
.post-module__tile__footer_count___oCbQY [class*=" icon-"]:nth-child(3) {
  margin-left: 12px;
}
@media screen and (max-width: 480px) {
  .post-module__tile__footer_count___oCbQY [class^=icon-]:nth-child(3),
  .post-module__tile__footer_count___oCbQY [class*=" icon-"]:nth-child(3) {
    margin-left: 7px;
  }
}
.post-module__tile__footer_count___oCbQY .post-module__text___yT2a5 {
  min-width: 27px;
  display: inline-block;
  text-align: center;
}
@media screen and (max-width: 480px) {
  .post-module__tile__footer_count___oCbQY .post-module__text___yT2a5 {
    font-size: 0.75rem;
  }
}
.post-module__tile__box___ZmynY {
  color: var(--primary600, #4b286d);
  float: left;
  width: 50%;
  padding: 2px 0 0;
  text-align: center;
  border: 0;
  background: var(--surface1, #fff);
  height: 40px;
}
.post-module__tile__box___ZmynY .post-module__flag-icon__body___pv8L5 {
  margin: 0 3px;
  line-height: 36px;
  white-space: nowrap;
}
@media screen and (max-width: 480px) {
  .post-module__tile__box___ZmynY .post-module__flag-icon__body___pv8L5 {
    font-size: 0.75rem;
  }
}
.post-module__tile__box___ZmynY.post-module__inactive___cQJPS {
  color: var(--neutral75, #424547);
}
.post-module__tile__box___ZmynY.post-module__inactive___cQJPS [class^=icon-],
.post-module__tile__box___ZmynY.post-module__inactive___cQJPS [class*=" icon-"] {
  font-size: 1.125rem;
}
.post-module__tile__box--full___CdcH2 {
  width: 100%;
}
.post-module__tile__boxin___fcFJ0 {
  display: inline-block;
}
.post-module__tile__item___GC4GC {
  border-bottom: 1px solid #e9eaea;
  padding: 10px;
}
.post-module__tile__item___GC4GC:last-child {
  border-bottom: none;
}
.post-module__tile__item--last___RQQJX {
  border-bottom: none !important;
}
.post-module__tile--padding___ysGip {
  padding-top: 30px;
}
.post-module__tile--details___C5CwC {
  margin: 20px auto 0;
  width: 90%;
}
.post-module__tile__twitter___FqeOy {
  color: var(--primary600, #4b286d) !important;
}
.post-module__tile__twitter___FqeOy:hover {
  color: var(--primary700, #371e47);
}

@media screen and (min-width: 768px) {
  .post-module__tile--details___C5CwC {
    margin: 50px auto 0;
    width: 40%;
  }
}
.post-module__post__badge-tag___ZYv6i {
  display: inline-block;
  font-weight: 600;
  padding: 1px 0px 9px;
  color: var(--neutral100, #2c2e30);
}

.post-module__post-menu____2xe8:after {
  content: "";
  width: 7px;
  height: 7px;
  transform: rotate(45deg);
  position: absolute;
  background: var(--surface1, #fff);
  top: -3px;
  left: calc(50% - 4px);
  border-top: 1px solid var(--neutral75, #424547);
  border-left: 1px solid var(--neutral75, #424547);
}

.post-module__sr-only____qqBe {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/feed/posts/post.module.scss","webpack://./node_modules/wa-storybook/components/general/styles/helpers/_media.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_focus-outline.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACMA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAEF;AAAE;EACE,kBAAA;EACA,MAAA;AAEJ;AACE;EACE,oBAAA;EACA,gBAAA;AACJ;AAII;EACE,8BAAA;AAFN;AAOE;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;AALJ;AAQE;EACE,mBAAA;EACA,sCAAA;AANJ;AAUE;EACE,iBAAA;EACA,iBAAA;EACA,iCAAA;AARJ;AAYE;EACE,cAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,gDAAA;EACA,sCAAA;EACA,0BAAA;AAVJ;AAaE;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,uCAAA;EACA,yBAAA;EACA,+BAAA;AAXJ;AAYI;EACE,WAAA;EACA,+BAAA;AAVN;AAcE;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,uCAAA;EACA,yBAAA;AAZJ;AAeE;EACE,qBAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,2CAAA;EACA,kBAAA;AAdJ;AAqBE;EAEE,sBAAA;AApBJ;AAuBE;EACE,mBAAA;EACA,aAAA;AArBJ;AClEI;EDqFF;IAII,kBAAA;EAnBJ;AACF;AAsBE;EACE,4BAAA;AApBJ;AAuBE;EACE,4CAAA,EAE+B,0BAAA;EAC/B,sBAAA;EAEA,0BAAA;AAvBJ;AE9FI;EACE,wCAAA;EACA,mBAAA;AFgGN;AAuBE;EACE,gBAAA;EACA,sBAAA;EACA,4CAAA,EAE+B,0BAAA;EAC/B,sBAAA;EACA,0BAAA;AAtBJ;AE1GI;EACE,wCAAA;EACA,mBAAA;AF4GN;AAqBI;EACE,yBAAA;EACA,eAAA;AAnBN;AAwBI;EACE,yBAAA,EAE+B,0BAAA;EAC/B,sBAAA;AAvBN;AA0BI;;EAEE,cAAA;EACA,kBAAA;AAxBN;AA2BI;EACE,mBAAA;AAzBN;AA4BI;EACE,mBAAA;AA1BN;AA8BE;EACE,kBAAA;EACA,gCAAA;AA5BJ;AA+BE;EACE,uCAAA;AA7BJ;AEzII;EACE,wCAAA;EACA,mBAAA;AF2IN;AA6BE;EACE,4CAAA;AA3BJ;AEhJI;EACE,wCAAA;EACA,mBAAA;AFkJN;AA2BE;EACE,gBAAA;AAzBJ;AA6BE;EAGE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,kDAAA;AA7BJ;AC/II;EDsKF;IAQI,kBAAA;IACA,gBAAA;EA3BJ;AACF;AA6BI;EAGE,qBAAA;AA7BN;AA+BM;EACE,0BAAA;AA7BR;AAiCE;EACE,kBAAA;AA/BJ;AAiCE;EACE,cAAA;EACA,iBAAA;AA/BJ;AAiCE;EACE,kBAAA;EACA,2BAAA;AA/BJ;AAiCE;EACE,kBAAA;EACA,6BAAA;AA/BJ;AAiCE;EACE,kBAAA;EACA,6BAAA;AA/BJ;AAiCE;EACE,2DAAA;AA/BJ;AAiCE;EACE,6DAAA;AA/BJ;AAiCE;EACE,6DAAA;AA/BJ;AAiCE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,+DAAA;EACA,OAAA;EACA,MAAA;AA/BJ;AAiCE;EACE,kBAAA;AA/BJ;AAkCE;EACE,kBAAA;EACA,sCAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AAhCJ;AAmCE;EACE,eAAA;EACA,iBAAA;EACA,2BAAA;AAjCJ;AAoCE;EACE,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAlCJ;AAoCI;EACE,WAAA;AAlCN;AAsCE;EACE,WAAA;AApCJ;AAuCE;EACE,sCAAA;EACA,gBAAA;EACA,uCAAA;AArCJ;AAsCI;EACE,yBAAA;AApCN;ACvOI;ED0QA;IAGI,yBAAA;EAlCN;AACF;AAoCI;EACE,uCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,iBAAA;EACA,iBAAA;AAlCN;ACtPI;EDgRA;IAUI,gBAAA;IACA,YAAA;IACA,oBAAA;EAhCN;AACF;AAkCM;;EAEE,iBAAA;EACA,mBAAA;EACA,2BAAA;AAhCR;ACnQI;ED+RE;;IAMI,kBAAA;IACA,sBAAA;EA7BR;AACF;AA8BQ;;EACE,iBAAA;AA3BV;AC9QI;EDwSI;;IAGI,gBAAA;EAxBV;AACF;AA4BM;EACE,eAAA;EACA,qBAAA;EACA,kBAAA;AA1BR;ACzRI;EDgTE;IAKI,kBAAA;EAxBR;AACF;AA6BE;EACE,iCAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,iCAAA;EACA,YAAA;AA3BJ;AA4BI;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;AA1BN;AC7SI;EDoUA;IAKI,kBAAA;EAxBN;AACF;AA0BI;EACE,gCAAA;AAxBN;AAyBM;;EAEE,mBAAA;AAvBR;AA4BE;EACE,WAAA;AA1BJ;AA6BE;EACE,qBAAA;AA3BJ;AAiCE;EACE,gCAAA;EACA,aAAA;AA/BJ;AAgCI;EACE,mBAAA;AA9BN;AAkCE;EACE,8BAAA;AAhCJ;AAoCE;EACE,iBAAA;AAlCJ;AAsCE;EACE,mBAAA;EACA,UAAA;AApCJ;AAuCE;EACE,4CAAA;AArCJ;AAsCI;EACE,iCAAA;AApCN;;ACtVI;EDiYA;IACE,mBAAA;IACA,UAAA;EAvCJ;AACF;AA2CA;EACE,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iCAAA;AAzCF;;AA6CE;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,iCAAA;EACA,SAAA;EACA,qBAAA;EACA,+CAAA;EACA,gDAAA;AA1CJ;;AA8CA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AA3CF","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../general/styles/variables.module.scss';\n@import '../../general/styles/helpers/_media.scss';\n@import '../../../styles/utils.scss';\n\n$spacing: 20px;\n\n.tile {\n  display: block;\n  position: relative;\n  font-weight: 400;\n  margin: 0 10px 50px;\n\n  &__modal-image {\n    position: absolute;\n    top: 0;\n  }\n\n  &__small-text {\n    font-size: rem(9);\n    padding-top: 2px;\n  }\n\n  //Badge align on top\n  &__badge {\n    .flag__image {\n      vertical-align: top !important;\n    }\n  }\n\n  //Time stamp\n  &__time {\n    margin-bottom: 5px;\n    margin-left: 5px;\n    font-size: rem(11);\n    font-weight: 600;\n    text-align: right;\n    color: color(neutral75);\n  }\n\n  &__border {\n    border-radius: 50px;\n    border: 4px solid color(base);\n  }\n\n  //Tile Header, contain image and link\n  &__header {\n    padding: 0 20px 0;\n    margin-top: -55px;\n    color: color(neutral100);\n  }\n\n  //Avatar of the tile\n  &__avatar {\n    display: block;\n    border-radius: 50px;\n    height: 70px;\n    width: 70px;\n    margin: 0 auto;\n    box-shadow: 0px 0px 0px 4px color(base);\n    background-color: color(base);\n    transition: all 0.25s ease;\n  }\n\n  &__avatar--small {\n    height: 50px;\n    width: 50px;\n    box-shadow: none;\n    background-color: color(surface1);\n    transition: all 0.1s ease;\n    margin: 0 18px 0 6px !important;\n    &.small-width {\n      width: 43px;\n      margin: 0 25px 0 6px !important;\n    }\n  }\n\n  &__avatar--extra-small {\n    height: 40px;\n    width: 40px;\n    box-shadow: none;\n    background-color: color(surface1);\n    transition: all 0.1s ease;\n  }\n\n  &__avatar--list {\n    display: inline-block;\n    border: none;\n    vertical-align: middle;\n    margin: 5px;\n    margin-bottom: 20px;\n  }\n\n  &__avatar--list--user {\n    border: 1px solid color(neutral30);\n    border-radius: 50%;\n  }\n\n  &__avatar:hover {\n    //transform:scale(1.05);\n  }\n\n  &__avatar--small:hover,\n  &__avatar--extra-small:hover {\n    transform: scale(1.05);\n  }\n\n  &__content {\n    font-size: rem(14);\n    padding: 20px;\n    @include media($mobile-s) {\n      padding: 15px 10px;\n    }\n  }\n\n  &__content--inverse {\n    color: color(surface1);\n  }\n\n  &__link {\n    color: color(primary600) !important;\n    -webkit-transition: color $hover-default-duration-in ease-out\n      $hover-default-duration-out; /* For Safari 3.1 to 6.0 */\n    transition: color $hover-default-duration-in;\n    @include focus-outline;\n    text-decoration: underline;\n  }\n\n  //Username\n  &__username {\n    font-weight: 600;\n    word-break: break-word;\n    color: color(primary600) !important;\n    -webkit-transition: color $hover-default-duration-in ease-out\n      $hover-default-duration-out; /* For Safari 3.1 to 6.0 */\n    transition: color $hover-default-duration-in;\n    text-decoration: underline;\n    @include focus-outline;\n\n    &:hover {\n      color: $dark-primary !important;\n      cursor: pointer;\n    }\n  }\n\n  &__html {\n    a {\n      color: $primary !important;\n      -webkit-transition: color $hover-default-duration-in ease-out\n        $hover-default-duration-out; /* For Safari 3.1 to 6.0 */\n      transition: color $hover-default-duration-in;\n    }\n\n    ul,\n    ol {\n      margin: 10px 0;\n      padding-left: 28px;\n    }\n\n    ul li {\n      list-style: initial;\n    }\n\n    ol li {\n      list-style: decimal;\n    }\n  }\n\n  &__job {\n    font-size: rem(12);\n    color: color(neutral75);\n  }\n\n  &__username--inverse {\n    color: color(surface1) !important;\n    @include focus-outline;\n  }\n\n  &__username--dark {\n    color: color(neutral100) !important;\n    @include focus-outline;\n  }\n\n  &__emphasize {\n    font-weight: 600;\n  }\n\n  //Text and username, kind of title of the post\n  &__headline {\n    $headline: &;\n\n    padding: 20px;\n    min-height: 100px;\n    font-size: rem(18);\n    border-bottom: 1px solid color(neutral30);\n    @include media($mobile-s) {\n      padding: 15px 10px;\n      min-height: 90px;\n    }\n\n    &:hover,\n    &:active,\n    &:focus {\n      text-decoration: none;\n\n      #{$headline}--username {\n        text-decoration: underline;\n      }\n    }\n  }\n  &__subtext {\n    font-size: rem(12);\n  }\n  &__text--padding {\n    margin: 15px 0;\n    padding-top: 42px;\n  }\n  &__text--first {\n    text-align: center;\n    color: color(gold);\n  }\n  &__text--second {\n    text-align: center;\n    color: color(silver);\n  }\n  &__text--third {\n    text-align: center;\n    color: color(bronze);\n  }\n  &__image--first {\n    box-shadow: 0 0 0 2px white, 0 0 0 4px color(gold);\n  }\n  &__image--second {\n    box-shadow: 0 0 0 2px white, 0 0 0 4px color(silver);\n  }\n  &__image--third {\n    box-shadow: 0 0 0 2px white, 0 0 0 4px color(bronze);\n  }\n  &__overlay {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(color(neutral100, true), 0.25);\n    left: 0;\n    top: 0;\n  }\n  &__inner-content {\n    position: relative;\n  }\n\n  &__activity {\n    padding: 10px 20px;\n    border-top: 1px solid color(neutral15);\n    color: color(neutral100);\n    text-align: left;\n    font-size: rem(12);\n    opacity: 1;\n    position: relative;\n  }\n\n  &__icon {\n    font-size: rem(16);\n    margin-right: 5px;\n    vertical-align: text-bottom;\n  }\n\n  &__photo--holder {\n    margin: 0 20px 20px;\n    transition: all 0.25s ease;\n    cursor: pointer;\n    max-height: 500px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n\n    & > img {\n      width: 100%;\n    }\n  }\n\n  &__photo {\n    width: 100%;\n  }\n\n  &__footer {\n    border-top: 1px solid color(neutral15);\n    overflow: hidden;\n    background-color: color(surface1);\n    &_action {\n      width: calc(100% - 145px);\n      @include media($mobile-s) {\n        width: calc(100% - 106px);\n      }\n    }\n    &_count {\n      border-left: 1px solid color(neutral15);\n      width: 145px;\n      height: 40px;\n      position: absolute;\n      right: 0;\n      color: color(neutral75);\n      padding: 9px 15px;\n      line-height: 40px - 2 * 9px;\n      @include media($mobile-s) {\n        padding: 9px 5px;\n        width: 106px;\n        line-height: initial;\n      }\n\n      [class^='icon-'],\n      [class*=' icon-'] {\n        margin: 0 5px 0 0;\n        font-size: rem(18);\n        vertical-align: text-bottom;\n        @include media($mobile-s) {\n          font-size: rem(12);\n          vertical-align: middle;\n        }\n        &:nth-child(3) {\n          margin-left: 12px;\n          @include media($mobile-s) {\n            margin-left: 7px;\n          }\n        }\n      }\n\n      .text {\n        min-width: 27px;\n        display: inline-block;\n        text-align: center;\n        @include media($mobile-s) {\n          font-size: rem(12);\n        }\n      }\n    }\n  }\n\n  &__box {\n    color: color(primary600);\n    float: left;\n    width: 50%;\n    padding: 2px 0 0;\n    text-align: center;\n    border: 0;\n    background: color(surface1);\n    height: 40px;\n    .flag-icon__body {\n      margin: 0 3px;\n      line-height: 36px;\n      white-space: nowrap;\n      @include media($mobile-s) {\n        font-size: rem(12);\n      }\n    }\n    &.inactive {\n      color: color(neutral75);\n      [class^='icon-'],\n      [class*=' icon-'] {\n        font-size: rem(18);\n      }\n    }\n  }\n\n  &__box--full {\n    width: 100%;\n  }\n\n  &__boxin {\n    display: inline-block;\n  }\n\n  //----------------SPECIFIC CLASS FOR TILE TYPES ------------------------//\n\n  //---------MOST RECOGNIZED------------//\n  &__item {\n    border-bottom: 1px solid #e9eaea;\n    padding: 10px;\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  &__item--last {\n    border-bottom: none !important;\n  }\n\n  //When no more hero\n  &--padding {\n    padding-top: 30px;\n  }\n\n  //Feed details page\n  &--details {\n    margin: 20px auto 0;\n    width: 90%;\n  }\n\n  &__twitter {\n    color: color(primary600) !important;\n    &:hover {\n      color: color(primary700);\n    }\n  }\n}\n\n@include media($tablet) {\n  .tile {\n    &--details {\n      margin: 50px auto 0;\n      width: 40%;\n    }\n  }\n}\n\n.post__badge-tag {\n  display: inline-block;\n  font-weight: 600;\n  padding: 1px 0px 9px;\n  color: color(neutral100);\n}\n\n.post-menu {\n  &:after {\n    content: '';\n    width: 7px;\n    height: 7px;\n    transform: rotate(45deg);\n    position: absolute;\n    background: color(surface1);\n    top: -3px;\n    left: calc(50% - 4px);\n    border-top: 1px solid color(neutral75);\n    border-left: 1px solid color(neutral75);\n  }\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n","@mixin media($query:$feature $value $columns, $total-columns: $grid-columns) {\n\n  @if length($query) == 1 {\n    @media screen and ($default-feature: nth($query, 1)) {\n      $default-grid-columns: $grid-columns;\n      $grid-columns: $total-columns;\n      @content;\n      $grid-columns: $default-grid-columns;\n    }\n  }\n\n  @else if length($query) == 2 {\n    @media screen and (nth($query, 1): nth($query, 2)) {\n      $default-grid-columns: $grid-columns;\n      $grid-columns: $total-columns;\n      @content;\n      $grid-columns: $default-grid-columns;\n    }\n  }\n\n  @else if length($query) == 3 {\n    @media screen and (nth($query, 1): nth($query, 2)) {\n      $default-grid-columns: $grid-columns;\n      $grid-columns: nth($query, 3);\n      @content;\n      $grid-columns: $default-grid-columns;\n    }\n  }\n\n  @else if length($query) == 4 {\n    @media screen and (nth($query, 1): nth($query, 2)) and (nth($query, 3): nth($query, 4)) {\n      $default-grid-columns: $grid-columns;\n      $grid-columns: $total-columns;\n      @content;\n      $grid-columns: $default-grid-columns;\n    }\n  }\n\n  @else if length($query) == 5 {\n    @media screen and (nth($query, 1): nth($query, 2)) and (nth($query, 3): nth($query, 4)) {\n      $default-grid-columns: $grid-columns;\n      $grid-columns: nth($query, 5);\n      @content;\n      $grid-columns: $default-grid-columns;\n    }\n  }\n\n  @else {\n    @warn \"Wrong number of arguments for breakpoint(). Read the documentation for more details.\";\n  }\n}\n","@import '../functions/color';\n\n@mixin focus-outline($color: color(focus), $applyDirectly: false) {\n  @if $applyDirectly {\n    outline: $color solid 2px;\n    outline-offset: 3px;\n  } @else {\n    &:focus {\n      outline: $color solid 2px;\n      outline-offset: 3px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tile": `post-module__tile___YAufs`,
	"tile__modal-image": `post-module__tile__modal-image___yC_MI`,
	"tile__small-text": `post-module__tile__small-text___cG5pI`,
	"tile__badge": `post-module__tile__badge___vquo8`,
	"flag__image": `post-module__flag__image___p0krp`,
	"tile__time": `post-module__tile__time___LFIxU`,
	"tile__border": `post-module__tile__border___Ni8l8`,
	"tile__header": `post-module__tile__header___WFvxr`,
	"tile__avatar": `post-module__tile__avatar___SWu3U`,
	"tile__avatar--small": `post-module__tile__avatar--small___ta_lu`,
	"small-width": `post-module__small-width___jm_uE`,
	"tile__avatar--extra-small": `post-module__tile__avatar--extra-small___eAXnY`,
	"tile__avatar--list": `post-module__tile__avatar--list___Flrfc`,
	"tile__avatar--list--user": `post-module__tile__avatar--list--user___GdROm`,
	"tile__content": `post-module__tile__content___y5Val`,
	"tile__content--inverse": `post-module__tile__content--inverse___M2M2F`,
	"tile__link": `post-module__tile__link___IqWa5`,
	"tile__username": `post-module__tile__username___WKcUW`,
	"tile__html": `post-module__tile__html___yoodh`,
	"tile__job": `post-module__tile__job___eugwg`,
	"tile__username--inverse": `post-module__tile__username--inverse___hKCcV`,
	"tile__username--dark": `post-module__tile__username--dark___O9_c0`,
	"tile__emphasize": `post-module__tile__emphasize___M884G`,
	"tile__headline": `post-module__tile__headline___JRJPp`,
	"tile__headline--username": `post-module__tile__headline--username___lQUq1`,
	"tile__subtext": `post-module__tile__subtext___MaBd7`,
	"tile__text--padding": `post-module__tile__text--padding___xXzG7`,
	"tile__text--first": `post-module__tile__text--first___E5B3j`,
	"tile__text--second": `post-module__tile__text--second___YlbGp`,
	"tile__text--third": `post-module__tile__text--third___Wdvqz`,
	"tile__image--first": `post-module__tile__image--first___w6dEX`,
	"tile__image--second": `post-module__tile__image--second___RlqG7`,
	"tile__image--third": `post-module__tile__image--third___Xqajf`,
	"tile__overlay": `post-module__tile__overlay___KiPv5`,
	"tile__inner-content": `post-module__tile__inner-content___QcV19`,
	"tile__activity": `post-module__tile__activity___AObFg`,
	"tile__icon": `post-module__tile__icon___o1chr`,
	"tile__photo--holder": `post-module__tile__photo--holder___WWaV6`,
	"tile__photo": `post-module__tile__photo___zGglD`,
	"tile__footer": `post-module__tile__footer___v4Rf9`,
	"tile__footer_action": `post-module__tile__footer_action___bRRPW`,
	"tile__footer_count": `post-module__tile__footer_count___oCbQY`,
	"text": `post-module__text___yT2a5`,
	"tile__box": `post-module__tile__box___ZmynY`,
	"flag-icon__body": `post-module__flag-icon__body___pv8L5`,
	"inactive": `post-module__inactive___cQJPS`,
	"tile__box--full": `post-module__tile__box--full___CdcH2`,
	"tile__boxin": `post-module__tile__boxin___fcFJ0`,
	"tile__item": `post-module__tile__item___GC4GC`,
	"tile__item--last": `post-module__tile__item--last___RQQJX`,
	"tile--padding": `post-module__tile--padding___ysGip`,
	"tile--details": `post-module__tile--details___C5CwC`,
	"tile__twitter": `post-module__tile__twitter___FqeOy`,
	"post__badge-tag": `post-module__post__badge-tag___ZYv6i`,
	"post-menu": `post-module__post-menu____2xe8`,
	"sr-only": `post-module__sr-only____qqBe`
};
export default ___CSS_LOADER_EXPORT___;
